import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  StripeCardElementOptions,
  StripeElementLocale,
  StripeElementsOptions,
} from '@stripe/stripe-js';
import { StripeCardComponent } from 'ngx-stripe';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-bank-card-form',
    templateUrl: './bank-card-form.component.html',
    styleUrls: ['./bank-card-form.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        StripeCardComponent,
    ],
})
export class BankCardFormComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() currentLanguage: StripeElementLocale = 'en';
  @ViewChild(StripeCardComponent) stripeCard: StripeCardComponent;
  @Output() bankCardFormReady = new EventEmitter<{
    bankCardForm: FormGroup | null;
    stripeCard: StripeCardComponent | null;
  }>();

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        // color: '#31325F',
        // fontWeight: '300',
        // fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        // fontSize: '18px',
        // '::placeholder': {
        //   color: '#CFD7E0',
        // },
      },
    },
  };

  elementsOptions: StripeElementsOptions = {
    locale: this.currentLanguage,
  };

  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.currentLanguage) {
      this.elementsOptions = { locale: this.currentLanguage };
    }
  }

  ngOnDestroy(): void {
    this.bankCardFormReady.emit({
      bankCardForm: null,
      stripeCard: null,
    });
  }

  ngAfterViewInit(): void {
    this.bankCardFormReady.emit({
      bankCardForm: this.form,
      stripeCard: this.stripeCard,
    });
  }
}
